module.exports = __webpack_public_path__ + "img/COMBO TWIRL BW.e877dc0.svg";